import type { ScenarioConditionMatchV1, ScenarioConditionV1, ScenarioState, ScenarioTriggerType } from 'api/scenarios';
import type { TTag } from 'types';

// prettier-ignore
export const stateLabels: Record<ScenarioState, string> = { draft: '下書き', active: '配信中', paused: '停止中', archived: 'アーカイブ' };
// prettier-ignore
// prettier-ignore
export const triggerLabels: Record<ScenarioTriggerType, string> = { friend_add: '友だち追加', tag_added: 'タグ付与', manual: '手動登録' };
/** components/ManagementCard の Pill のトーン名。 */
// prettier-ignore
export const stateTones: Record<ScenarioState, 'neutral' | 'success' | 'warning'> = { draft: 'neutral', active: 'success', paused: 'warning', archived: 'neutral' };

const tagName = (tags: TTag[], tagId: number | null) => tags.find(({ id }) => id === tagId)?.name;

/** 送信成功時に付けるタグの説明。タグを解決できないときはnullにして何も出さない。 */
export function reachTagLabel(tagId: number | null, tags: TTag[]): string | null {
  const name = tagName(tags, tagId);
  return name ? `送信できたらタグ「${name}」を付けます` : null;
}

/** 条件の種類を、選択肢としてそのまま読める日本語にする。 */
// prettier-ignore
export const conditionMatchLabels: Record<ScenarioConditionMatchV1, string> = {
  tag_all: '選んだタグをすべて持っている',
  tag_any: '選んだタグのいずれかを持っている',
  tag_none: '選んだタグをどれも持っていない',
};

/** 消えたタグを黙って省くと条件を読み違えるので、その旨を名前として出す。 */
const tagNames = (condition: ScenarioConditionV1, tags: TTag[]) =>
  condition.tagIds.map((tagId) => tagName(tags, tagId) ?? '不明なタグ');

/** その道を通る側から見た、タグの持ち方。 */
type Held = 'all' | 'any' | 'none' | 'not_all';
// prettier-ignore
const heldOf = (type: ScenarioConditionMatchV1, satisfied: boolean): Held =>
  type === 'tag_all' ? (satisfied ? 'all' : 'not_all')
  : type === 'tag_any' ? (satisfied ? 'any' : 'none')
  : satisfied ? 'none' : 'any';

/**
 * 分岐の線に出す「〜の場合」。線ごとに、その道を通る条件をそのまま書く。
 * @param condition 対象の送信条件
 * @param tags 組織のタグ
 * @param satisfied その線が条件を満たした側か
 * @returns 「タグ「VIP」がついている場合」のような文
 */
export function conditionCaseLabel(condition: ScenarioConditionV1, tags: TTag[], satisfied: boolean): string {
  const names = tagNames(condition, tags);
  if (!names.length) return satisfied ? '条件を満たす場合' : '条件を満たさない場合';
  const held = heldOf(condition.type, satisfied);
  // 1件なら「すべて」「いずれか」は冗長になるので、ついている／いないだけを書く
  if (names.length === 1) return `タグ「${names[0]}」がついて${held === 'all' || held === 'any' ? 'いる' : 'いない'}場合`;
  const list = names.map((name) => `「${name}」`).join('');
  // prettier-ignore
  const tail = held === 'all' ? 'がすべてついている'
    : held === 'any' ? 'のいずれかがついている'
    : held === 'none' ? 'がどれもついていない'
    : 'のどれかがついていない';
  return `タグ${list}${tail}場合`;
}
